export const formatCamelCase = (string) =>
  string
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .split(/[ -]+/)
    .filter((char) => char.trim().length > 0)
    .join('')
